import memoize from "memoize-one";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function initGoogleFont() {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).WebFontConfig = {
    google: {
      families: ["Source+Sans+Pro:400,600,700"],
    },
  };
  const wf = document.createElement("script");
  const src = document.location.protocol === "https:" ? "https" : "http";
  wf.src = `${src}://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js`;
  wf.type = "text/javascript";
  wf.async = true;
  const s = document.getElementsByTagName("script")[0];
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  return s.parentNode.insertBefore(wf, s);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const memoizedIsInIframe = memoize((cypressInstance: any) => window !== window.top && cypressInstance === undefined);
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isInIframe() {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return memoizedIsInIframe((window as any).Cypress);
}
